/**
 * The dragonslayer pack (ADR 0031): not a dragon's hide but its trophies, a
 * hunter who wears what he took from the wyrm he slew. Bleached bone and
 * tanned leather, red runes carved in the bone that pulse and shed embers,
 * animated like the founder's fire set (four frames of their own in the
 * rig). Kept apart from the dragon set's red scales and from Shefira's raid
 * gear on purpose: ivory and brown here, never scales worn as armour. The
 * griffon carries, the falcon hunts at the right hand.
 */
const TEMPLATES = [
    {
        id: 'dragonslayer-helm',
        lootable: false,
        cosmetic: true,
        name: 'Crâne de wyrm',
        kind: 'equipment',
        slot: 'helmet',
        rarity: 'legendary',
        sprite: 'overlay.dragonslayer-helm',
        icon: 'icon.dragonslayer-helm',
    },
    {
        id: 'dragonslayer-chest',
        lootable: false,
        cosmetic: true,
        name: 'Cuirasse d’ossements',
        kind: 'equipment',
        slot: 'chest',
        rarity: 'legendary',
        sprite: 'overlay.dragonslayer-chest',
        icon: 'icon.dragonslayer-chest',
    },
    {
        id: 'dragonslayer-gloves',
        lootable: false,
        cosmetic: true,
        name: 'Gantelets d’ossements',
        kind: 'equipment',
        slot: 'gloves',
        rarity: 'legendary',
        sprite: 'overlay.dragonslayer-gloves',
        icon: 'icon.dragonslayer-gloves',
    },
    {
        id: 'dragonslayer-boots',
        lootable: false,
        cosmetic: true,
        name: 'Bottes d’ossements',
        kind: 'equipment',
        slot: 'boots',
        rarity: 'legendary',
        sprite: 'overlay.dragonslayer-boots',
        icon: 'icon.dragonslayer-boots',
    },
    {
        id: 'dragonslayer-sword',
        lootable: false,
        cosmetic: true,
        name: 'Croc de wyrm',
        kind: 'equipment',
        slot: 'weapon',
        rarity: 'legendary',
        sprite: 'overlay.dragonslayer-sword',
        icon: 'icon.dragonslayer-sword',
    },
    {
        id: 'dragonslayer-shield',
        lootable: false,
        cosmetic: true,
        name: 'Écaille de wyrm',
        kind: 'equipment',
        slot: 'offhand',
        rarity: 'legendary',
        classes: ['warrior'],
        sprite: 'overlay.dragonslayer-shield',
        icon: 'icon.dragonslayer-shield',
    },
    {
        id: 'griffon',
        lootable: false,
        name: 'Griffon',
        kind: 'equipment',
        slot: 'mount',
        rarity: 'legendary',
        companion: 'griffon',
        icon: 'icon.griffon',
    },
    {
        id: 'hunting-falcon',
        lootable: false,
        name: 'Faucon de chasse',
        kind: 'equipment',
        slot: 'pet',
        rarity: 'legendary',
        companion: 'hunting-falcon',
        icon: 'icon.hunting-falcon',
    },
];
/** Priced like the founder's fire set, piece for piece; the griffon like the fire horse. */
const OFFERS = [
    {
        id: 'dragonslayer-sword',
        name: 'Croc de wyrm',
        blurb: 'Le croc d’un wyrm monté sur une garde d’os, gravé de runes rouges qui battent comme un cœur. Animé.',
        pack: 'dragonslayer',
        items: [{ templateId: 'dragonslayer-sword' }],
        priceCents: 399,
    },
    {
        id: 'dragonslayer-helm',
        name: 'Crâne de wyrm',
        blurb: 'Le crâne blanchi d’un dragon abattu, cornes en arrière, runes rouges dans les orbites. Animé.',
        pack: 'dragonslayer',
        items: [{ templateId: 'dragonslayer-helm' }],
        priceCents: 299,
    },
    {
        id: 'dragonslayer-chest',
        name: 'Cuirasse d’ossements',
        blurb: 'Cuir tanné et côtes de dragon sanglées sur le torse, les runes rouges crachant des braises. Animée.',
        pack: 'dragonslayer',
        items: [{ templateId: 'dragonslayer-chest' }],
        priceCents: 399,
    },
    {
        id: 'dragonslayer-gloves',
        name: 'Gantelets d’ossements',
        blurb: 'Des gants de cuir aux jointures d’os, une rune rouge qui luit sur chaque poing. Animés.',
        pack: 'dragonslayer',
        items: [{ templateId: 'dragonslayer-gloves' }],
        priceCents: 199,
    },
    {
        id: 'dragonslayer-boots',
        name: 'Bottes d’ossements',
        blurb: 'Des bottes de cuir aux jambières d’os, où couvent des runes rouges. Animées.',
        pack: 'dragonslayer',
        items: [{ templateId: 'dragonslayer-boots' }],
        priceCents: 199,
    },
    {
        id: 'dragonslayer-shield',
        name: 'Écaille de wyrm',
        blurb: 'Une seule écaille, grande comme un homme, arrachée au wyrm et marquée d’une rune ardente. Animée.',
        pack: 'dragonslayer',
        items: [{ templateId: 'dragonslayer-shield' }],
        priceCents: 299,
    },
    {
        id: 'griffon',
        name: 'Griffon',
        blurb: 'Tête et ailes d’aigle, corps de lion : une monture fière, deux fois plus rapide que tes jambes.',
        pack: 'dragonslayer',
        items: [{ templateId: 'griffon' }],
        priceCents: 599,
    },
    {
        id: 'hunting-falcon',
        name: 'Faucon de chasse',
        blurb: 'Un faucon chaperonné de cuir qui se tient à ta droite et part chercher ton butin.',
        pack: 'dragonslayer',
        items: [{ templateId: 'hunting-falcon' }],
        priceCents: 299,
    },
    {
        id: 'dragonslayer-pack',
        name: 'Pack du Tueur de dragon',
        blurb: 'Les trophées d’un wyrm abattu : crâne, cuirasse, gantelets et bottes d’ossements, son croc et son écaille, le griffon sous ta selle et le faucon de chasse à tes côtés.',
        pack: 'dragonslayer',
        items: [
            { templateId: 'dragonslayer-sword' },
            { templateId: 'dragonslayer-helm' },
            { templateId: 'dragonslayer-chest' },
            { templateId: 'dragonslayer-gloves' },
            { templateId: 'dragonslayer-boots' },
            { templateId: 'dragonslayer-shield' },
            { templateId: 'griffon' },
            { templateId: 'hunting-falcon' },
        ],
        priceCents: 999,
        worthCents: 3492,
    },
];
export const DRAGONSLAYER = { templates: TEMPLATES, offers: OFFERS };
//# sourceMappingURL=dragonslayer.js.map